module.exports = __webpack_public_path__ + "static/media/ic-service-train.e368d84c.svg";